import { GROUP_API_URL, MAPPING_API_URL } from '@/services/constants';
import axiosClient from '../axiosClient';

const GroupServices = {
  fetchAllGroups: async (page?: any, rowsPerPage?: any, groupName?: string, domainName?: string) => {
    const response = await axiosClient.get(`${GROUP_API_URL}`, {
      params: {
        domainName: domainName,
        pageNumber: page,
        pageSize: rowsPerPage,
        groupName
      }
    });
    return response.data;
  },
  createGroup: async (body: any, domainName: any) => {
    try {
      const response = await axiosClient.post(`${GROUP_API_URL}`, body);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  deleteGroup: async (groupId: string, domainName: any) => {
    try {
      const response = await axiosClient.delete(`${GROUP_API_URL}`, {
        params: {
          groupId,
          domainName
        }
      });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  updateGroup: async (body: any, groupId: any) => {
    try {
      const response = await axiosClient.put(`${GROUP_API_URL}/${groupId}`, body);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  deleteUsergp: async (body: any) => {
    try {
      const response = await axiosClient.post(`${MAPPING_API_URL}`, body);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  downloadGroup: async () => {
    try {
      const response = await axiosClient.get(`${GROUP_API_URL}/download`);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  uploadCsv: async (params: any) => {
    
    const response = await axiosClient.post(`${GROUP_API_URL}/UploadCsv`, params?.data, {
      headers: {
        'Content-Type': 'application/JSON'
      },
      params: {
        dom_name: params?.dom_name,
        created_by: params?.created_by,
        modified_by: params?.modified_by,
        status: params?.status
      }
    });
    return response.data;
  },
  downloadCsv: async () => {
    try {
      const response = await axiosClient.get(`${GROUP_API_URL}/downloadsamplefile`);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  }
};

export default GroupServices;
